var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGamification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.333 38.5003H25.6663C20.533 38.5003 16.333 34.3003 16.333 29.167V10.5003C16.333 9.10033 17.2663 8.16699 18.6663 8.16699H37.333C38.733 8.16699 39.6663 9.10033 39.6663 10.5003V29.167C39.6663 34.3003 35.4663 38.5003 30.333 38.5003Z",
    stroke: "#0069FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 38.5002V47.8336",
    stroke: "#0069FF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47.8337H35",
    stroke: "#0069FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.667 15.167H46.667C48.067 15.167 49.0003 16.1003 49.0003 17.5003V22.167C49.0003 26.1337 45.967 29.167 42.0003 29.167H39.667",
    stroke: "#0069FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 15.167H9.33333C7.93333 15.167 7 16.1003 7 17.5003V22.167C7 26.1337 10.0333 29.167 14 29.167H16.3333",
    stroke: "#0069FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamification);
export default __webpack_public_path__ + "static/media/Gamification.9ef3fe54c69697dcfcf294056efc8319.svg";
export { ForwardRef as ReactComponent };